import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                width: '100%',
                position: 'fixed',
                bottom: 0,
                backgroundColor: '#f8f6f4',
                color: 'black',
                p: 2,
                textAlign: 'center'
            }}
        >
            <Typography component="p">© 2023 - Noodle Fresh & Tasty</Typography>
        </Box>
    );
}

export default Footer;